// The road's preload (spec FE-09): the road this phone will get (the 3D street with three.js, or
// the flat road with PixiJS; see game/road.ts) is fetched while the lobby waits, so the countdown
// never waits on the network, and the 3D street for the park's map starts baking. Once per map; a
// failure just leaves it to the road, which imports it again.
const roads = new Map<string, Promise<unknown>>();

/** Fetch the road and start baking `map` (the Park's route, or the Race ring). */
export function preloadRoad(map = 'lagos-route'): void {
  if (roads.has(map)) return;
  roads.set(
    map,
    import('../game/road')
      .then(({ chooseRoad, loadRoad }) => loadRoad(chooseRoad().kind, map))
      .catch(() => {
        roads.delete(map);
      }),
  );
}
